import React from "react";


import {WEBSERVER} from "../services/globals";

export default function CatPath({product}) {
  let path =`<a href="${WEBSERVER}">Home</a>/`;
  //console.log("collections:" + JSON.stringify(product.collections));
  for (let elem of  product.collections) {
    let link = WEBSERVER + "/category/" + elem.slug;
    path += `<a href="${link}">${elem.name}</a>/`;
  }
  
  return  ( <div dangerouslySetInnerHTML={{__html: path}} />);

}

